/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_LabelInputs */

const en_style_guide_manager_position_label = /** @type {(inputs: Style_Guide_Manager_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const fr_style_guide_manager_position_label = /** @type {(inputs: Style_Guide_Manager_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const de_style_guide_manager_position_label = /** @type {(inputs: Style_Guide_Manager_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const it_style_guide_manager_position_label = /** @type {(inputs: Style_Guide_Manager_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione`)
};

const ru_style_guide_manager_position_label = /** @type {(inputs: Style_Guide_Manager_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция`)
};

const es_style_guide_manager_position_label = /** @type {(inputs: Style_Guide_Manager_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición`)
};

const zh_cn2_style_guide_manager_position_label = /** @type {(inputs: Style_Guide_Manager_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

const ja_style_guide_manager_position_label = /** @type {(inputs: Style_Guide_Manager_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

const hi_style_guide_manager_position_label = /** @type {(inputs: Style_Guide_Manager_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पद`)
};

const pt_pt2_style_guide_manager_position_label = /** @type {(inputs: Style_Guide_Manager_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Style_Guide_Manager_Position_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_label = /** @type {((inputs?: Style_Guide_Manager_Position_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_position_label(inputs)
	if (locale === "de") return de_style_guide_manager_position_label(inputs)
	if (locale === "it") return it_style_guide_manager_position_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_position_label(inputs)
	if (locale === "es") return es_style_guide_manager_position_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_position_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_position_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_position_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_position_label(inputs)
	return en_style_guide_manager_position_label(inputs)
});